import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
} from 'reactstrap';
import Widget from '../../components/Widget/Widget.js';

import cloudIcon from '../../assets/tables/cloudIcon.svg';
import funnelIcon from '../../assets/tables/funnelIcon.svg';
import optionsIcon from '../../assets/tables/optionsIcon.svg';
import printerIcon from '../../assets/tables/printerIcon.svg';
import searchIcon from '../../assets/tables/searchIcon.svg';
import moreIcon from '../../assets/tables/moreIcon.svg';
import { toSmallCaps, formatTanggalIndonesia } from '../../utils/func.js';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import './table.css';
import s from './Tables.module.scss';
import mock from './mock.js';
import {
  API_TIMEOUT,
  GET_REKAP_DTSEN_DESA,
  GET_DTSEN_DESIL_DESA_DETAIL,
} from '../../utils/index.js';
import axios from 'axios';

import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { numberWithCommas } from '../../utils/func.js';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import TulufaliLogo from '../../components/Icons/tulufali_logo.png';

const Tables = function () {
  const [firstTable, setFirstTable] = useState([]);
  const [secondTable] = useState(mock.secondTable);
  const [transactions, setTransactions] = useState(mock.transactionsWidget);
  const [tasks, setTasks] = useState(mock.tasksWidget);
  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0);
  const [tableDropdownOpen, setTableMenuOpen] = useState(false);
  const [modalDesilDetail, setModalDesilDetail] = useState(false);
  const [desilDetailData, setDesilDetailData] = useState([]);
  const [desilDetailLoading, setDesilDetailLoading] = useState(false);
  const [desilDetailInfo, setDesilDetailInfo] = useState({
    desa: '',
    kecamatan: '',
    desil: 0,
  });
  const [searchFilter, setSearchFilter] = useState('');

  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    if (!currentUser) {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      setCurrentUser(currentUser);
    }
  }, []);

  useEffect(() => {
    ambilDataDesilDesa();
  }, []);

  const ambilDataDesilDesa = () => {
    axios({
      method: 'get',
      url: GET_REKAP_DTSEN_DESA,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return 'error';
        } else {
          //BERHASIL

          setFirstTable(response.data.data);
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  const searchLower = searchFilter.trim().toLowerCase();
  const filteredTable =
    !searchLower
      ? firstTable
      : firstTable.filter(
          (r) =>
            (r.desa && r.desa.toLowerCase().includes(searchLower)) ||
            (r.kecamatan && r.kecamatan.toLowerCase().includes(searchLower))
        );

  const pageSize = 100;
  const firstTablePagesCount = Math.ceil(filteredTable.length / pageSize);
  const secondTablePagesCount = Math.ceil(secondTable.length / pageSize);

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  };

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  };

  const toggleTask = (id) => {
    setTasks(
      tasks.map((task) => {
        if (task.id === id) {
          task.completed = !task.completed;
        }
        return task;
      })
    );
  };

  const openDesilDetailModal = (desa, kecamatan, desil, count) => {
    if (!count || count === 0) return;
    const desaVal = String(desa || '').trim();
    const kecVal = String(kecamatan || '').trim();
    if (!desaVal || !kecVal) return;
    setDesilDetailInfo({ desa: desaVal, kecamatan: kecVal, desil });
    setModalDesilDetail(true);
    setDesilDetailData([]);
    setDesilDetailLoading(true);
    axios({
      method: 'get',
      url: GET_DTSEN_DESIL_DESA_DETAIL,
      timeout: API_TIMEOUT,
      params: { desa: desaVal, kecamatan: kecVal, desil },
    })
      .then((res) => {
        const raw = res?.data;
        const arr = raw?.data ?? raw ?? [];
        setDesilDetailData(Array.isArray(arr) ? arr : []);
      })
      .catch(() => {
        setDesilDetailData([]);
      })
      .finally(() => {
        setDesilDetailLoading(false);
      });
  };

  const closeDesilDetailModal = () => {
    setModalDesilDetail(false);
    setDesilDetailData([]);
    setDesilDetailInfo({ desa: '', kecamatan: '', desil: 0 });
  };

  const handleDownloadModalPdf = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const now = new Date();
    const dateStr = now.toLocaleDateString('id-ID');
    const timeStr = now.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const footer = `Diunduh dari Tulu Fali Apps oleh ${user.nama || user.username || 'User'} pada ${dateStr} ${timeStr}`;
    const title = `Detail Desil ${desilDetailInfo.desil} - ${desilDetailInfo.desa}, ${desilDetailInfo.kecamatan}`;
    const doc = new jsPDF('l', 'mm', 'a4');
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 14, 8, 25, 25);
      } catch (e) {}
      doc.setFontSize(8);
      doc.text(footer, 45, 18);
      const head = [['No', 'Nama', 'NIK', 'NOKK', 'Jenis Kelamin', 'Tanggal Lahir', 'Alamat', 'Hubungan KK', 'Disabilitas', 'Bansos PKH', 'Bansos Sembako']];
      const body = desilDetailData.map((r, i) => [
        String(i + 1),
        r.nama || '-',
        r.NIK || '-',
        r.NOKK || '-',
        r.jenis_kelamin || '-',
        formatTanggalIndonesia(r.tanggal_lahir),
        r.alamat || r.desa || '-',
        r.hubungan_keluarga || '-',
        r.disabilitas || '-',
        r.bansos_pkh || '-',
        r.bansos_sembako || '-',
      ]);
      doc.autoTable({
        startY: 28,
        head,
        body,
        theme: 'grid',
        headStyles: { fillColor: [220, 220, 220] },
      });
      doc.save(`Detail-Desil-${desilDetailInfo.desa}-${desilDetailInfo.kecamatan}-Desil-${desilDetailInfo.desil}.pdf`);
    };
    img.onerror = () => {
      doc.setFontSize(8);
      doc.text(footer, 14, 18);
      const head = [['No', 'Nama', 'NIK', 'NOKK', 'Jenis Kelamin', 'Tanggal Lahir', 'Alamat', 'Hubungan KK', 'Disabilitas', 'Bansos PKH', 'Bansos Sembako']];
      const body = desilDetailData.map((r, i) => [
        String(i + 1),
        r.nama || '-',
        r.NIK || '-',
        r.NOKK || '-',
        r.jenis_kelamin || '-',
        formatTanggalIndonesia(r.tanggal_lahir),
        r.alamat || r.desa || '-',
        r.hubungan_keluarga || '-',
        r.disabilitas || '-',
        r.bansos_pkh || '-',
        r.bansos_sembako || '-',
      ]);
      doc.autoTable({
        startY: 25,
        head,
        body,
        theme: 'grid',
        headStyles: { fillColor: [220, 220, 220] },
      });
      doc.save(`Detail-Desil-${desilDetailInfo.desa}-${desilDetailInfo.kecamatan}-Desil-${desilDetailInfo.desil}.pdf`);
    };
    img.src = TulufaliLogo;
  };

  const totalDesil1 = filteredTable.reduce((sum, r) => sum + (r.Desil_1 ?? 0), 0);
  const totalDesil2 = filteredTable.reduce((sum, r) => sum + (r.Desil_2 ?? 0), 0);
  const totalDesil3 = filteredTable.reduce((sum, r) => sum + (r.Desil_3 ?? 0), 0);
  const totalDesil4 = filteredTable.reduce((sum, r) => sum + (r.Desil_4 ?? 0), 0);
  const totalDesil5 = filteredTable.reduce((sum, r) => sum + (r.Desil_5 ?? 0), 0);
  const totalDesil6_10 = filteredTable.reduce((sum, r) => sum + (r.Desil_6_10 ?? 0), 0);

  const getExportMeta = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const now = new Date();
    const dateStr = now.toLocaleDateString('id-ID');
    const timeStr = now.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const title = 'Data jumlah penduduk perdesa perdesil kesejahteraan (sumber: rekap DTSEN)';
    const filterNote = searchFilter.trim()
      ? `Filter: desa/kecamatan mengandung "${searchFilter.trim()}"`
      : null;
    return {
      userName: user.nama || user.username || 'User',
      dateTime: `${dateStr} ${timeStr}`,
      title,
      filterNote,
      footer: `Diunduh dari Tulu Fali Apps oleh ${user.nama || user.username || 'User'} pada ${dateStr} ${timeStr}`,
    };
  };

  const handleDownloadPdf = () => {
    const { title, filterNote, footer } = getExportMeta();
    const doc = new jsPDF('l', 'mm', 'a4');
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 14, 8, 25, 25);
      } catch (e) {
        // Skip logo if conversion fails
      }
      buildPdfContent(doc, title, filterNote, footer);
    };
    img.onerror = () => {
      buildPdfContent(doc, title, filterNote, footer);
    };
    img.src = TulufaliLogo;
  };

  const buildPdfContent = (doc, title, filterNote, footer) => {
    let y = 22;
    doc.setFontSize(8);
    doc.text(footer, 45, 18);
    y += 10;
    const totalPenduduk = filteredTable.reduce((s, r) => s + (r.jumlahOrang ?? 0), 0);
    doc.autoTable({
      startY: y,
      head: [['', 'Desil 1', 'Desil 2', 'Desil 3', 'Desil 4', 'Desil 5', 'Desil 6-10', 'Total Penduduk']],
      body: [['Rekap', numberWithCommas(totalDesil1), numberWithCommas(totalDesil2), numberWithCommas(totalDesil3), numberWithCommas(totalDesil4), numberWithCommas(totalDesil5), numberWithCommas(totalDesil6_10), numberWithCommas(totalPenduduk)]],
      theme: 'grid',
      headStyles: { fillColor: [220, 220, 220] },
    });
    y = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(14);
    doc.text(title, 14, y);
    y += 10;
    if (filterNote) {
      doc.setFontSize(10);
      doc.text(filterNote, 14, y);
      y += 8;
    }
    const tableData = filteredTable.map((r, i) => [
      i + 1,
      r.desa || '',
      r.kecamatan || '',
      String(r.Desil_1 ?? 0),
      String(r.Desil_2 ?? 0),
      String(r.Desil_3 ?? 0),
      String(r.Desil_4 ?? 0),
      String(r.Desil_5 ?? 0),
      String(r.Desil_6_10 ?? 0),
      String(r.jumlahOrang ?? 0),
    ]);
    doc.autoTable({
      startY: y,
      head: [['No', 'Desa', 'Kecamatan', 'Desil 1', 'Desil 2', 'Desil 3', 'Desil 4', 'Desil 5', 'Desil 6-10', 'Penduduk']],
      body: tableData,
      theme: 'grid',
    });
    doc.save(`Data-Desil-Perdesa-TuluFali-${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  const renderDesilCell = (item, desilNum, desilKey) => {
    const val = item[desilKey] ?? 0;
    const total = item.jumlahOrang ?? 0;
    const pct = total > 0 ? ((val / total) * 100).toFixed(1) : '0';
    return (
      <>
        <div>{numberWithCommas(val)}</div>
        <div className={`small text-muted ${s.desilPct}`}>{pct}%</div>
      </>
    );
  };

  return (
    <div>
      <Row>
        <Col>
          <Row className='mb-4'>
            <Col>
              <Widget className={s.desilDesaMinimal}>
                <div className={s.tableTitle}>
                  <div className='headline-2'>
                    Data jumlah penduduk perdesa perdesil kesejahteraan (sumber:
                    rekap DTSEN)
                  </div>
                  <div className={`d-flex align-items-center ${s.downloadBtnGroup}`}>
                    <ReactHTMLTableToExcel
                      table='dataDesilExport'
                      filename={`Data-Desil-Perdesa-TuluFali-${new Date().toISOString().slice(0, 10)}`}
                      sheet='Data'
                      className={s.btnDownloadExcel}
                      buttonText="Excel"
                    />
                    <Button
                      className={s.btnDownloadPdf}
                      onClick={handleDownloadPdf}
                    >
                      <i className="fa fa-file-pdf-o" aria-hidden="true" />
                      PDF
                    </Button>
                    <a>
                      <img src={printerIcon} alt='Printer' />
                    </a>
                    <a>
                      <img
                        className='d-none d-sm-block'
                        src={optionsIcon}
                        alt='Options'
                      />
                    </a>
                    <a>
                      <img src={funnelIcon} alt='Funnel' />
                    </a>
                  </div>
                </div>
                <div className={s.widgetBody}>
                  <div className={`mb-3 ${s.searchFilterWrap}`}>
                    <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <span className="input-group-text">
                        <i className="fa fa-search" aria-hidden="true" />
                      </span>
                    </InputGroupAddon>
                    <Input
                      type="text"
                      placeholder="Cari desa atau kecamatan..."
                      value={searchFilter}
                      onChange={(e) => {
                        setSearchFilter(e.target.value);
                        setFirstTableCurrentPage(0);
                      }}
                    />
                    </InputGroup>
                  </div>
                  <div className={`d-flex flex-wrap align-items-center mb-3 ${s.summaryChipsWrap}`}>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Desil 1</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalDesil1)}
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Desil 2</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalDesil2)}
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Desil 3</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalDesil3)}
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Desil 4</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalDesil4)}
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Desil 5</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalDesil5)}
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Desil 6-10</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalDesil6_10)}
                    </Badge>
                  </span>
                  </div>
                <div className='widget-table-overflow'>
                  <Table
                    id='dataDesilVisible'
                    className={`table-striped table-borderless table-hover ${s.statesTable}`}
                    responsive
                  >
                    <thead>
                      <tr>
                        <th className='w-10'>NOMOR</th>
                        <th className='w-25'>DESA</th>
                        <th className='w-25'>KECAMATAN</th>
                        <th className='w-25'>DESIL 1</th>
                        <th className='w-25'>DESIL 2</th>
                        <th className='w-25'>DESIL 3</th>
                        <th className='w-25'>DESIL 4</th>
                        <th className='w-25'>DESIL 5</th>
                        <th className='w-25'>DESIL 6-10</th>
                        <th className='w-25'>
                          <span>PENDUDUK</span>
                          <small className="d-block text-muted font-weight-normal" style={{ fontSize: '0.75rem' }}>
                            (sumber: rekap DTSEN)
                          </small>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTable
                        .slice(
                          firstTableCurrentPage * pageSize,
                          (firstTableCurrentPage + 1) * pageSize
                        )
                        .map((item, index) => (
                          <tr key={item.id || uuidv4()}>
                            <td>
                              {firstTableCurrentPage * pageSize + index + 1}
                            </td>
                            <td>{toSmallCaps(item.desa)}</td>
                            <td>{toSmallCaps(item.kecamatan)}</td>
                            <td
                              className={s.desilCell}
                              onClick={() =>
                                openDesilDetailModal(
                                  item.desa,
                                  item.kecamatan,
                                  1,
                                  item.Desil_1 ?? 0
                                )
                              }
                            >
                              {renderDesilCell(item, 1, 'Desil_1')}
                            </td>
                            <td
                              className={s.desilCell}
                              onClick={() =>
                                openDesilDetailModal(
                                  item.desa,
                                  item.kecamatan,
                                  2,
                                  item.Desil_2 ?? 0
                                )
                              }
                            >
                              {renderDesilCell(item, 2, 'Desil_2')}
                            </td>
                            <td
                              className={s.desilCell}
                              onClick={() =>
                                openDesilDetailModal(
                                  item.desa,
                                  item.kecamatan,
                                  3,
                                  item.Desil_3 ?? 0
                                )
                              }
                            >
                              {renderDesilCell(item, 3, 'Desil_3')}
                            </td>
                            <td
                              className={s.desilCell}
                              onClick={() =>
                                openDesilDetailModal(
                                  item.desa,
                                  item.kecamatan,
                                  4,
                                  item.Desil_4 ?? 0
                                )
                              }
                            >
                              {renderDesilCell(item, 4, 'Desil_4')}
                            </td>
                            <td
                              className={s.desilCell}
                              onClick={() =>
                                openDesilDetailModal(
                                  item.desa,
                                  item.kecamatan,
                                  5,
                                  item.Desil_5 ?? 0
                                )
                              }
                            >
                              {renderDesilCell(item, 5, 'Desil_5')}
                            </td>
                            <td>
                              {renderDesilCell(item, 6, 'Desil_6_10')}
                            </td>
                            <td>{numberWithCommas(item.jumlahOrang)}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  <Pagination
                    className='pagination-borderless'
                    aria-label='Page navigation example'
                  >
                    <PaginationItem disabled={firstTableCurrentPage <= 0}>
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage - 1)
                        }
                        previous
                        href='#top'
                      />
                    </PaginationItem>
                    {[...Array(firstTablePagesCount)].map((page, i) => (
                      <PaginationItem
                        active={i === firstTableCurrentPage}
                        key={i}
                      >
                        <PaginationLink
                          onClick={(e) => setFirstTablePage(e, i)}
                          href='#top'
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem
                      disabled={
                        firstTableCurrentPage >= firstTablePagesCount - 1
                      }
                    >
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage + 1)
                        }
                        next
                        href='#top'
                      />
                    </PaginationItem>
                  </Pagination>
                </div>
                <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
                  <table id="dataDesilExport">
                    <thead>
                      <tr>
                        <td colSpan="10" style={{ fontSize: '10px', color: '#666' }}>
                          Diunduh dari Tulu Fali Apps oleh {getExportMeta().userName} pada {getExportMeta().dateTime}
                        </td>
                      </tr>
                      <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                        <td colSpan="2">Rekap Total</td>
                        <td></td>
                        <td>{numberWithCommas(totalDesil1)}</td>
                        <td>{numberWithCommas(totalDesil2)}</td>
                        <td>{numberWithCommas(totalDesil3)}</td>
                        <td>{numberWithCommas(totalDesil4)}</td>
                        <td>{numberWithCommas(totalDesil5)}</td>
                        <td>{numberWithCommas(totalDesil6_10)}</td>
                        <td>{numberWithCommas(filteredTable.reduce((s, r) => s + (r.jumlahOrang ?? 0), 0))}</td>
                      </tr>
                      <tr>
                        <td colSpan="10" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          Data jumlah penduduk perdesa perdesil kesejahteraan (sumber: rekap DTSEN)
                        </td>
                      </tr>
                      {searchFilter.trim() && (
                        <tr>
                          <td colSpan="10" style={{ fontSize: '12px' }}>
                            Filter: desa/kecamatan mengandung &quot;{searchFilter.trim()}&quot;
                          </td>
                        </tr>
                      )}
                      <tr>
                        <th>No</th>
                        <th>Desa</th>
                        <th>Kecamatan</th>
                        <th>Desil 1</th>
                        <th>Desil 2</th>
                        <th>Desil 3</th>
                        <th>Desil 4</th>
                        <th>Desil 5</th>
                        <th>Desil 6-10</th>
                        <th>Penduduk</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTable.map((r, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{r.desa || ''}</td>
                          <td>{r.kecamatan || ''}</td>
                          <td>{numberWithCommas(r.Desil_1 ?? 0)}</td>
                          <td>{numberWithCommas(r.Desil_2 ?? 0)}</td>
                          <td>{numberWithCommas(r.Desil_3 ?? 0)}</td>
                          <td>{numberWithCommas(r.Desil_4 ?? 0)}</td>
                          <td>{numberWithCommas(r.Desil_5 ?? 0)}</td>
                          <td>{numberWithCommas(r.Desil_6_10 ?? 0)}</td>
                          <td>{numberWithCommas(r.jumlahOrang ?? 0)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal
        size='lg'
        isOpen={modalDesilDetail}
        toggle={closeDesilDetailModal}
      >
        <ModalHeader toggle={closeDesilDetailModal}>
          Detail Desil {desilDetailInfo.desil} - {desilDetailInfo.desa},{' '}
          {desilDetailInfo.kecamatan}
        </ModalHeader>
        <ModalBody className={s.modalDesilDetailWrap}>
          {(desilDetailData.length > 0 && !desilDetailLoading) && (
            <div className={`d-flex justify-content-end align-items-center mb-3 ${s.downloadBtnGroup}`}>
              <ReactHTMLTableToExcel
                id="modalDetailExcelBtn"
                table="modalDesilDetailExport"
                filename={`Detail-Desil-${desilDetailInfo.desa}-${desilDetailInfo.kecamatan}-Desil-${desilDetailInfo.desil}`}
                sheet="Detail"
                buttonText="Excel"
                className={s.btnDownloadExcel}
              />
              <Button className={s.btnDownloadPdf} onClick={handleDownloadModalPdf}>
                <i className="fa fa-file-pdf-o" aria-hidden="true" />
                PDF
              </Button>
            </div>
          )}
          {desilDetailLoading ? (
            <div className='text-center py-4'>Memuat data...</div>
          ) : desilDetailData.length === 0 ? (
            <div className='text-center py-4 text-muted'>
              Tidak ada data
            </div>
          ) : (
            <div className='table-responsive'>
              <Table size='sm' striped id="modalDesilDetailExport">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama</th>
                    <th>NIK</th>
                    <th>NOKK</th>
                    <th>Jenis Kelamin</th>
                    <th>Tanggal Lahir</th>
                    <th>Alamat</th>
                    <th>Hubungan KK</th>
                    <th>Disabilitas</th>
                    <th>Bansos PKH</th>
                    <th>Bansos Sembako</th>
                  </tr>
                </thead>
                <tbody>
                  {desilDetailData.map((row, idx) => (
                    <tr key={row.NIK || `${idx}-${row.nama}`}>
                      <td>{idx + 1}</td>
                      <td>{row.nama || '-'}</td>
                      <td>{row.NIK || '-'}</td>
                      <td>{row.NOKK || '-'}</td>
                      <td>{row.jenis_kelamin || '-'}</td>
                      <td>{formatTanggalIndonesia(row.tanggal_lahir)}</td>
                      <td>{row.alamat || row.desa || '-'}</td>
                      <td>{row.hubungan_keluarga || '-'}</td>
                      <td>{row.disabilitas || '-'}</td>
                      <td>{row.bansos_pkh || '-'}</td>
                      <td>{row.bansos_sembako || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Tables;
